import { render, staticRenderFns } from "./RecipeEditPage.vue?vue&type=template&id=4a7e6cfb&"
import script from "./RecipeEditPage.vue?vue&type=script&lang=js&"
export * from "./RecipeEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports